import React, { useState } from "react";
import { Form, Row, Col, Button } from "antd";
import TextInput from "../CommonFormItems/TextInput/TextInput";

import PostalCodeFieldsBlock from "../CommonFormItems/PostalCodeFieldsBlock/PostalCodeFieldsBlock";

function RecipientForm({ form, activeRecipient, actions, formType, callback }) {
  const { getFieldDecorator, setFieldsValue, setFields } = form;
  const { addRecipient, toggleGenericModal } = actions;
  const [isPostalCodeLoading, setIsPostalCodeLoading] = useState(false);

  let formTypeTitle = formType === "recipientEditForm" ? "Editar" : "Crear";
  const activeRecipientPostalFieldsValues = {
    postalCode: activeRecipient?.postalCode,
    city: activeRecipient?.city,
    country: activeRecipient?.country,
    cityCode: activeRecipient?.cityCode,
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    form.validateFields((err, values) => {
      if (!err) {
        const trimmedAlias =
          typeof values.alias === "string" ? values.alias.trim() : undefined;
        const normalizedAlias = trimmedAlias === "" ? undefined : trimmedAlias;

        let recipientValues = activeRecipient
          ? {
              ...values,
              alias: normalizedAlias,
              participantId: activeRecipient?.participantId,
            }
          : { ...values, alias: normalizedAlias };
        callback(recipientValues);
      }
    });
  };

  return (
    <div className="RecipientForm">
      <h3>{`${formTypeTitle} destinatario`}</h3>
      <Form onSubmit={handleSubmit}>
        <Row type="flex" justify="center">
          <Col span={11}>
            <TextInput
              label="Nombre de destinatario particular / empresa"
              name="name"
              getFieldDecorator={getFieldDecorator}
              initialValue={activeRecipient?.name}
              required
              requiredMessage="Campo obligatorio"
              placeholder="Ej: José Pérez o Rótulos García S.A"
              pattern={/^\S.{1,298}\S$/u}
              patternMessage="Valor no válido. Están permitidos entre 3 y 300 caracteres, sin espacios al inicio o fin del texto"
            />
          </Col>
          <Col span={11} offset={1}>
            <TextInput
              label="Alias de destinatario particular / empresa"
              name="alias"
              getFieldDecorator={getFieldDecorator}
              initialValue={activeRecipient?.alias}
              placeholder="Ej: Jose P"
            />
          </Col>
        </Row>
        <Row type="flex" justify="center" gutter={24}>
          <Col span={23}>
            <TextInput
              label="Dirección"
              name="address"
              getFieldDecorator={getFieldDecorator}
              initialValue={activeRecipient?.address}
              required
              requiredMessage="Campo obligatorio"
              placeholder="Ej: Calle de los Ríos, 24, 3ºB"
              pattern={/^[^\s].{3,198}[^\s]$/u}
              patternMessage="Valor no válido. Están permitidos entre 5 y 200 caracteres, sin espacios al inicio o fin del texto"
            />
          </Col>
        </Row>
        <PostalCodeFieldsBlock
          form={form}
          initialFormValues={activeRecipientPostalFieldsValues}
          loadingSetter={setIsPostalCodeLoading}
          loadingState={isPostalCodeLoading}
          editMode
        />
        <Row type="flex" justify="center">
          <Col span={7}>
            <TextInput
              label="Email"
              name="email"
              getFieldDecorator={getFieldDecorator}
              initialValue={activeRecipient?.email}
              required
              requiredMessage="Campo obligatorio"
              pattern={/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/}
              placeholder="Ej: luissanchez@examplemail.com"
            />
          </Col>
          <Col span={7} offset={1}>
            <TextInput
              label="Teléfono móvil"
              name="mobilePhone"
              getFieldDecorator={getFieldDecorator}
              initialValue={activeRecipient?.mobilePhone}
              required
              requiredMessage="Campo obligatorio"
              pattern={/^[67]\d{8}$/}
              placeholder="Ej: 661234572"
              maxLength={9}
            />
          </Col>
          <Col span={7} offset={1}>
            <TextInput
              label="NIE/NIF/Otros"
              name="documentId"
              getFieldDecorator={getFieldDecorator}
              initialValue={activeRecipient?.documentId}
              placeholder="Introduzca NIF/NIE/Otros"
              pattern={/^(?! )[A-Za-z0-9 ]{5,15}(?<! )$/}
              patternMessage="Valor no válido. Están permitidos entre 5 y 15 caracteres, sin espacios al inicio o fin del texto."
            />
          </Col>
        </Row>
        <Row type="flex" justify="center">
          <Col span={7}>
            <TextInput
              label="Persona de contacto"
              name="contactPerson"
              getFieldDecorator={getFieldDecorator}
              initialValue={activeRecipient?.contactPerson}
              placeholder="Ej: Antonio Castillo"
              pattern={/^[^\s][\p{L}0-9.,\s]{1,298}[^\s]$/u}
              patternMessage="Valor no válido. Están permitidos entre 3 y 300 caracteres sin espacios al inicio o fin del texto."
            />
          </Col>
          <Col span={7} offset={1}>
            <TextInput
              label="Teléfono de contacto"
              name="contactPhone"
              getFieldDecorator={getFieldDecorator}
              initialValue={activeRecipient?.contactPhone}
              required
              requiredMessage="Campo obligatorio"
              pattern={/^\d{9,15}$/}
              placeholder="Ej: 661234572 ó 912345678"
              maxLength={15}
            />
          </Col>
          <Col span={7} offset={1}></Col>
        </Row>
        <Row>
          <div className="buttons-container">
            <Button
              disabled={isPostalCodeLoading}
              type="danger"
              ghost
              onClick={toggleGenericModal}
              className="cancel-btn"
            >
              Cancelar
            </Button>
            <Button
              disabled={isPostalCodeLoading}
              htmlType="submit"
              className={isPostalCodeLoading ? "disabled" : "save-btn"}
            >
              Guardar
            </Button>
          </div>
        </Row>
      </Form>
    </div>
  );
}

export default Form.create()(RecipientForm);
